var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { API_GET_DOMAIN_SETTINGS, API_URL_SETTING, API_URL_SETTINGS, } from ".";
// public
// link domain with lobby
// 1toM
export const getUrlSettings = (domain, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_URL_SETTINGS + domain);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("urlsettings not found");
            }
        }
        throw new Error("server error");
    }
});
export const addUrlSettingItem = (domain, data, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.post(API_URL_SETTINGS + domain, data);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("urlsetting not found");
            }
            if (serverResponse && serverResponse.status === 400) {
                throw new Error("urlsetting already exists or invalid url");
            }
        }
        throw new Error("server error");
    }
});
export const getUrlSettingItem = (urlSettingId, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_URL_SETTING + urlSettingId);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("urlsetting not found");
            }
        }
        throw new Error("server error");
    }
});
export const deleteUrlSettingItem = (urlSettingId, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield api.delete(API_URL_SETTING + urlSettingId);
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("urlsetting not found");
            }
        }
        throw new Error("server error");
    }
});
export const updateUrlSettingItem = (urlSettingId, data, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.put(API_URL_SETTING + urlSettingId, data);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("urlsetting not found");
            }
        }
        throw new Error("server error");
    }
});
export const getDomainSettings = (domain, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_GET_DOMAIN_SETTINGS + `${domain}/settings`);
        return response.data;
    }
    catch (err) {
        return {
            domain,
            use_separate_url: true,
            allow_guest_user: true,
            allow_auto_airdrop: false,
            pause_auto_airdrop: false,
            domain_allowlist: [],
            ads_list_number: 0,
            is_premium: false,
        };
    }
});
//# sourceMappingURL=url.js.map